/**
 * Physical jewelry label — GC420t roll measured by shop:
 *   total 88 mm wide × 10 mm tall
 *
 *   |← empty 44 →|← barcode 20 →|← gap 5 →|← Plata/Bs 19 →|
 *   0            44              64         69              88
 *
 * Gap AFTER the barcode before material/price.
 * Fold mark ~22 mm on the empty neck is for wrapping only.
 */
export const LABEL_PRINT_WIDTH_MM = 88;
export const LABEL_PRINT_HEIGHT_MM = 10;
/** Physical fold mark on the empty neck (guide only). */
export const LABEL_FOLD_MM = 22;
/** Gap between labels on the physical roll (mm). */
export const LABEL_PRINT_GAP_MM = 3;

/** Empty left tail. */
export const LABEL_EMPTY_MM = 44;

/** Panel 1: code + barcode. */
export const LABEL_BARCODE_LEFT_MM = LABEL_EMPTY_MM; // 44
export const LABEL_BARCODE_WIDTH_MM = 20;

/** Space after barcode before Plata/Bs. */
export const LABEL_AFTER_BARCODE_GAP_MM = 5;

/** Panel 2: Plata / Bs. */
export const LABEL_INFO_LEFT_MM =
  LABEL_BARCODE_LEFT_MM + LABEL_BARCODE_WIDTH_MM + LABEL_AFTER_BARCODE_GAP_MM; // 69
export const LABEL_INFO_WIDTH_MM = LABEL_PRINT_WIDTH_MM - LABEL_INFO_LEFT_MM; // 19

/** Kept for imports that still reference a generic panel size. */
export const LABEL_PANEL_MM = 22;

/** GC420t: 203 dpi → 8 dots per mm. */
export const LABEL_DOTS_PER_MM = 8;

export function mmToDots(mm: number): number {
  return Math.round(mm * LABEL_DOTS_PER_MM);
}
